export function TypeScale() {
  return (
    <div className="space-y-10">
      <div>
        <p className="font-mono text-[0.65rem] uppercase tracking-widest text-ink-tertiary">
          Títulos — Inter (peso forte)
        </p>
        <p className="mt-2 font-display text-5xl font-extrabold leading-[1.1] tracking-tight text-ink sm:text-6xl">
          Mistério com peso
        </p>
      </div>
      <div>
        <p className="font-mono text-[0.65rem] uppercase tracking-widest text-ink-tertiary">
          Corpo — Inter
        </p>
        <p className="mt-2 text-2xl font-light leading-snug text-ink">
          Corpo elegante, leve, reservado.
        </p>
        <p className="mt-3 max-w-prose text-sm font-normal leading-relaxed text-ink-secondary">
          Inter foi desenhada para ecrãs: boa distinção entre glifos, altura-x
          confortável e pesos claros para texto longo. Hierarquia secundária com
          peso regular e cor mais suave.
        </p>
      </div>
      <div>
        <p className="font-mono text-[0.65rem] uppercase tracking-widest text-ink-tertiary">
          Mono — IBM Plex Mono
        </p>
        <p className="mt-2 font-mono text-sm font-medium text-ink-tertiary">
          LABEL · MICROCOPY · NAVEGAÇÃO DISCRETA
        </p>
      </div>
    </div>
  );
}
